import React, { useEffect, useState } from "react";
import ListaProductos from "../General/ListaProductos";
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Snackbar, Stack, Typography } from "@mui/material";
import { getData } from "../../../../../../../services/library";
import DefinicionVariableEspecial from "../General/DefinicionVariableEspecial";
import { UrlApi } from "../../../../../../../services/apirest";
import moment from "moment";

function ActualizarEspecialParticular({ open, setOpen, onClose, row }) {
  const [monto, setMonto] = useState("");
  const [porcentaje, setPorcentaje] = useState("");
  const [precioMinimo, setPrecioMinimo] = useState("");
  // const [precioMaximo, setPrecioMaximo] = useState("");
  const [tipoOperacion, setTipoOperacion] = useState("");

  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const validarInput = (value) => /^-?\d*\.?\d*$/.test(value);
  const handleMontoChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setMonto(value);
      if (value !== "") setPorcentaje("");
      setTipoOperacion("monto");
    }
  };

  const handlePorcentajeChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPorcentaje(value);
      if (value !== "") setMonto("");
      setTipoOperacion("porcentaje");
    }
  };

  const handlePrecioMinimo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMinimo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  // const handlePrecioMaximo = (e) => {
  //   const value = e.target.value;
  //   if (validarInput(value)) {
  //     setPrecioMaximo(value);
  //     if (value !== "") setMonto("");
  //     setTipoOperacion("precio");
  //   }
  // };

  const handleClose = () => {
    onClose(false);
  };

  
  const handleActualizarPrecios = async (e) => {
    e.preventDefault();

    const valor = parseFloat(monto || porcentaje);
    let nuevoMin = row.precio_minimo;
    // let nuevoMax = row.precio_maximo;

    if (tipoOperacion === "monto") {
      nuevoMin += valor;
      // nuevoMax += valor;
    } else if (tipoOperacion === "porcentaje") {
      const factor = valor / 100;
      nuevoMin += nuevoMin * factor;
      // nuevoMax += nuevoMax * factor;
    } else {
      nuevoMin = precioMinimo;
      // nuevoMax = precioMaximo;
    }

    const actualizado = {
      id: row.id,
      precio_minimo: Math.round(nuevoMin),
      // precio_maximo: Math.round(nuevoMax),
    };

 try {
    // 1) Actualizo el precio en especiales
    const resp = await fetch(
      `${UrlApi}/envasado_precios_especiales/xID/${actualizado.id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          precio_minimo: actualizado.precio_minimo,
          // precio_maximo: actualizado.precio_maximo,
        }),
      }
    );

    const data = await resp.json();

    if (!data.err) {
      console.log("Guardado");

      const historial = {
        producto: row.producto,
        cliente: row.cliente,
        precio_minimo_anterior: row.precio_minimo,
        precio_minimo_nuevo: actualizado.precio_minimo,
        fecha: moment().format("YYYY-MM-DD"),
        usuario: localStorage.getItem("user"),
      };

      await fetch(`${UrlApi}/envasado_historial_especial`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(historial),
      });

      // 4) Feedback al usuario
      setOpenSnack(true);
      setColorMensaje("#D4EFDF");
      setMensaje("La variación se guardó exitosamente !");
    } else {
      console.log("Error");
    }
  } catch (err) {
    console.error("Error actualizando precios", err);
  }
};

  const isPrecioMinMaxValido = precioMinimo !== "" ;
const isMontoOPorcentajeValido = (monto !== "" || porcentaje !== "") && !isPrecioMinMaxValido;
const isGuardarDisabled =
  openSnack || // si está mostrando snackbar, bloquear
  (!isPrecioMinMaxValido && !isMontoOPorcentajeValido); 

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth={"xl"}>
        <form
          onSubmit={handleActualizarPrecios}
          style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
        >
          <Box bgcolor="#1F618D">
            <DialogTitle
              sx={{
                bgcolor: "#1F618D",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                position: "relative",
                p: 1,
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 1,
                  textAlign: "center",
                  pr: 4,
                }}
              >
                Actualizar Precio
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent sx={{ p: 1.8 }}>
            <DefinicionVariableEspecial
              monto={monto}
              porcentaje={porcentaje}
              precioMinimo={precioMinimo}
              // precioMaximo={precioMaximo}
              handleMontoChange={handleMontoChange}
              handlePorcentajeChange={handlePorcentajeChange}
              handlePrecioMinimo={handlePrecioMinimo}
              // handlePrecioMaximo={handlePrecioMaximo}
            />
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "space-between",
              p: 1,
              position: "sticky",
              bottom: 0,
            }}
          >
            <Button
              color="error"
              variant="contained"
              onClick={handleClose}
              sx={{ minWidth: 120 }}
            >
              Volver
            </Button>

            <Button
              color="success"
              type="submit"
              variant="contained"
              sx={{ minWidth: 120 }}
              disabled={isGuardarDisabled}
            >
              Confirmar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  )
}

export default ActualizarEspecialParticular;
